import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Carousel,
  CarouselIndicators,
  CarouselItem,
  CarouselControl,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  FormGroup,
  ModalFooter,
} from "reactstrap";
import { getAllService } from "../../slices/services/thunk";
import { fetchAllOffers } from "../../slices/offer/thunk";
import { fetchCustomerSummary } from "../../slices/customer/simulate/thunk";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import moment from "moment";
import CommonButton from "../Utils/CommonButton";
import { submitChangePlan } from "../Customers/constants/ChangePlanSubmitFunction";
import { useLocation, useNavigate } from "react-router-dom";
import { jsonForAddOn } from "./Constant/JsonForAddOn";
import { calculateValidity } from "./Constant/DateValidity";
import { Loader } from "../Utils/Loader";
import SelfcareOfferCard from "./SelfcareOfferCard";
const ChangePlan = () => {
  const dispatch = useDispatch();
  const dispatchForChangePlan = useDispatch();
  const customerId = localStorage.getItem("customerId");
  const subscriptionId = customerIdData();
  const location = useLocation();
  const navigate = useNavigate();
  const isSelfcareChangePlan = location.pathname.includes(
    "selfcare-changeplan"
  );
  const isAddOn = !isSelfcareChangePlan;
  let simulateOrPreview = "";
  const [activeTab, setActiveTab] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  // const [animating, setAnimating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [groupedPlans, setGroupedPlans] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [modalStep, setModalStep] = useState(1);
  const [immediate, setImmediate] = useState(false);
  const [immediateMinus, setImmediateMinus] = useState(false);
  const [nextBillCycle, setNextBillCycle] = useState(false);
  const [postExpiry, setPostExpiry] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  useEffect(() => {
    if (!isSelfcareChangePlan) {
      setModalStep(2);
    }
  }, [isSelfcareChangePlan]);
  const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    setImmediate(false);
    setImmediateMinus(false);
    setNextBillCycle(false);
    setPostExpiry(false);
    switch (value) {
      case "immediate":
        setImmediate(true);
        break;
      case "immediateMinus":
        setImmediateMinus(true);
        break;
      case "next":
        setNextBillCycle(true);
        break;
      case "postExpiry":
        setPostExpiry(true);
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    dispatch(getAllService(setLoading));
    dispatch(fetchAllOffers(setLoading));
    simulateOrPreview = "View";
    dispatch(fetchCustomerSummary(customerId, setLoading, simulateOrPreview));
  }, []);
  const serviceData = useSelector((state) => state.Services.services);
  const offers = useSelector((state) => state.Offer.offer);
  const fetchCustomerSummaryData = useSelector(
    (state) => state.Simulate.simulate
  );
  const matchingResource = fetchCustomerSummaryData?.resources?.find(
    (resource) =>
      resource.subscriptionId === subscriptionId && !resource.isAddOn
  );
  const matchingResourceArray =
    fetchCustomerSummaryData?.resources?.filter(
      (resource) => resource.subscriptionId === subscriptionId
    ) || [];
  const matchedOffers = offers
    .filter((offer) => offer.addOnOffer !== isSelfcareChangePlan)

    .map((offer) => {
      const matchedService = serviceData.find(
        (service) => service.serviceCode === offer.serviceCode
      );
      if (matchedService) {
        return {
          serviceName: matchedService.name,
          serviceCode: matchedService.serviceCode,
          offerCode: offer.offerCode,
          offerName: offer.offerName,
          startDate: offer.validity?.from || "N/A",
          endDate: offer.validity?.to || "N/A",
          amount: offer.Charges?.[0]?.amount || 0,
          Grants: offer.Grants || [],
          description: offer?.description,
        };
      }
      return null;
    })
    .filter(Boolean);

  const groupedOffers = matchedOffers.reduce((acc, offer) => {
    acc[offer.serviceName] = acc[offer.serviceName] || [];
    const grants = offer.Grants || [];

    let description = offer?.description?.trim() ? offer.description : "";
    if (!description && grants.length > 0) {
      description = grants
        .map(
          (grant) =>
            `${grant.amount} ${grant.measuringUnits || ""} ${
              grant.resourceName
            }`
        )
        .join(", ");
    }
    const isCurrentPlan =
      matchingResourceArray.some(
        (resource) => resource.offerCode === offer.offerCode
      ) && isSelfcareChangePlan;
    acc[offer.serviceName].push({
      title: offer.offerName,
      offerCode: offer.offerCode,
      price: `₹${offer.amount || 0}`,
      validity: calculateValidity(offer.startDate, offer.endDate) + " Days",
      description: description || "No Grants available!",
      startDate: offer.startDate,
      endDate: offer.endDate,
      isCurrentPlan: isCurrentPlan,
    });
    return acc;
  }, {});
  useEffect(() => {
    if (Object.keys(groupedOffers).length > 0 && !activeTab) {
      setActiveTab(Object.keys(groupedOffers)[0]);
    }
  }, [groupedOffers]);

  const handleConfirm = () => {
    if (modalStep === 1) {
      setModalStep(2);
    } else {
      if (isSelfcareChangePlan) {
        submitChangePlan(
          customerId,
          selectedPlan?.offerCode,
          subscriptionId,
          immediate,
          immediateMinus,
          nextBillCycle,
          setLoading,
          dispatchForChangePlan,
          true,
          postExpiry,
          matchingResource?.offerCode,
          isSelfcareChangePlan,
          navigate
        );
      } else {
        jsonForAddOn(
          subscriptionId,
          selectedPlan?.offerCode,
          customerId,
          dispatch,
          setLoading,
          navigate,
          isAddOn
        );
      }
      toggleModal();
      setModalStep(1);
    }
  };

  const [activeIndices, setActiveIndices] = useState({});

  const next = (key, chunkCount) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: ((prev[key] ?? 0) + 1) % chunkCount,
    }));
  };

  const previous = (key, chunkCount) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: ((prev[key] ?? 0) - 1 + chunkCount) % chunkCount,
    }));
  };

  const goToIndex = (key, index) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: index,
    }));
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMediumToLargeScreen, setIsMediumToLargeScreen] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1400
  );
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsMediumToLargeScreen(
        window.innerWidth >= 768 && window.innerWidth < 1400
      );
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const offerSlides = (offers, serviceIndex) => {
    const numberOfItems = isMobile ? 1 : isMediumToLargeScreen ? 3 : 4;
    const offerChunks = [];
    for (let i = 0; i < offers.length; i += numberOfItems) {
      offerChunks.push(offers.slice(i, i + numberOfItems));
    }

    const slides = offerChunks.map((offerChunk, index) => (
      <CarouselItem
        key={`chunk-${index}`}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <div className="d-flex justify-content-center w-100">
          <Row className="px-2 w-95">
            {offerChunk.map((offer, offerIndex) => {
              const adjustedOfferIndex = index * numberOfItems + offerIndex;
              return (
                <Col
                  key={adjustedOfferIndex}
                  lg={4}
                  xxl={3}
                  sm={12}
                  className="mb-4"
                >
                  <SelfcareOfferCard
                    offer={offer}
                    index={serviceIndex}
                    offerIndex={adjustedOfferIndex}
                    handleSelect={(plan) => {
                      setSelectedPlan(plan);
                      setModalOpen(true);
                    }}
                  />
                </Col>
              );
            })}
          </Row>
        </div>
      </CarouselItem>
    ));

    return { slides, chunkCount: offerChunks.length };
  };

  return (
    <React.Fragment>
      <div id="csms" className="page-content bg-white">
        <Container fluid>
          {loading && <Loader data-testid="loader" />}
          <ToastContainer position="top-center" />
          <h5 className="text-uppercase fw-bold rv-text-primary-color mb-4 mt-2">
            {isSelfcareChangePlan ? "Change Plan" : "Add On"}
          </h5>
          <Row>
            <Col lg={12}>
              <div className="offers">
                <div>
                  {Object.keys(groupedOffers)?.map((off, index) => {
                    const { slides, chunkCount } = offerSlides(
                      groupedOffers[off],
                      index
                    );
                    const indicators = [];
                    for (let i = 0; i < chunkCount; i++) {
                      indicators.push({ key: "ind-" + i });
                    }
                    const currentIndex = activeIndices[off] || 0;
                    return (
                      <div key={index} className="py-3">
                        <div className="d-flex justify-content-center w-100">
                          <Row className="px-2 w-95">
                            <Col md={4} xxl={3} sm={12}>
                              <h2 className="fs-5 text-black fw-bold mb-0">
                                {off}
                              </h2>
                            </Col>
                          </Row>
                        </div>

                        <Carousel
                          activeIndex={currentIndex}
                          next={() => next(off, chunkCount)}
                          previous={() => previous(off, chunkCount)}
                          className="my-3"
                          interval={false}
                        >
                          <CarouselIndicators
                            items={indicators}
                            activeIndex={currentIndex}
                            onClickHandler={(newIdx) => goToIndex(off, newIdx)}
                          />

                          {slides}

                          <CarouselControl
                            direction="prev"
                            directionText="Previous"
                            onClickHandler={() => previous(off, chunkCount)}
                            className={currentIndex === 0 ? "d-none" : ""}
                          />
                          <CarouselControl
                            direction="next"
                            directionText="Next"
                            onClickHandler={() => next(off, chunkCount)}
                            className={
                              currentIndex == chunkCount - 1 ? "d-none" : ""
                            }
                          />
                        </Carousel>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          centered={true}
          size="lg"
          className="custom-modal"
        >
          <ModalHeader className="w-100 justify-content-center p-13 position-relative  ">
            {modalStep === 1 ? "Mode of Change" : "Confirm Plan"}
            <button
              type="button"
              className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
              onClick={toggleModal}
            >
              &times;
            </button>
          </ModalHeader>
          <ModalBody>
            {modalStep === 1 && isSelfcareChangePlan ? (
              <>
                <Row className="justify-content-center">
                  <Col sm="6">
                    <FormGroup className="border border-1 p-1 rounded-1">
                      <Label check>
                        <Input
                          type="radio"
                          className="mt-3 ms-1"
                          name="planOption"
                          value="immediate"
                          onChange={handleRadioChange}
                        />{" "}
                        <span className="mt-n1 ms-2">Immediate</span>
                      </Label>
                      <p className="changeplan-description tooltip-color-changeplan">
                        Changes immediately
                      </p>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup className="border border-1 rounded-1 p-1">
                      <Label check>
                        <Input
                          type="radio"
                          className="mt-3 ms-1"
                          name="planOption"
                          value="next"
                          onChange={handleRadioChange}
                        />
                        <span className="mt-n1 ms-2"> Next bill cycle</span>
                      </Label>
                      <p className="changeplan-description tooltip-color-changeplan">
                        Changes in next bill cycle
                      </p>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="mt-2 justify-content-center">
                  <Col sm="6">
                    <FormGroup className="border border-1 p-4 rounded-1">
                      <Label check>
                        <Input
                          type="radio"
                          className="ms-n3"
                          name="planOption"
                          value="immediateMinus"
                          onChange={handleRadioChange}
                        />
                        <span className="ms-2">Immediate Minus Used</span>
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup className="border border-1 p-4 rounded-1">
                      <Label check>
                        <Input
                          type="radio"
                          className="ms-n3"
                          name="planOption"
                          value="postExpiry"
                          onChange={handleRadioChange}
                        />
                        <span className="ms-2">Post Expiry</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Col className="mb-3">
                  <FormGroup className="border border-1 rounded-1 p-2">
                    <Label className="mb-2 fw-bold fs-5 ms-2 pl-2">
                      {!isSelfcareChangePlan ? "Base plan" : " Current Plan"}{" "}
                    </Label>
                    <Row className="mb-2">
                      <Col
                        lg={3}
                        className="justify-content-center fw-semibold text-start ms-2"
                      >
                        Plan Name
                      </Col>
                      <Col lg={4} className="fw-semibold">
                        Start Date
                      </Col>
                      <Col lg={4} className="fw-semibold">
                        End Date
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col lg={3} className="ms-2">
                        {matchingResource?.offerName}
                      </Col>
                      <Col lg={4}>
                        {moment(matchingResource?.validFrom).format(
                          "DD MMM YYYY"
                        )}
                      </Col>
                      <Col lg={4}>
                        {moment(matchingResource?.validTo).format(
                          "DD MMM YYYY"
                        )}
                      </Col>
                      <Col
                        lg={4}
                        className="mt-2 ms-2 fw-semibold invoice-icon-size plan-amount"
                      >
                        $30
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
                <Col className="mb-3">
                  <FormGroup
                    className="border border-1 rounded-1 p-2"
                    style={{ backgroundColor: "#FD754515" }}
                  >
                    <Label className="mb-2 fs-5 fw-bold ms-2">
                      {!isSelfcareChangePlan ? "Add On" : "New Plan"}
                    </Label>
                    <Row className="mb-2">
                      <Col lg={3} className="fw-semibold ms-2">
                        Plan Name
                      </Col>
                      <Col lg={4} className="fw-semibold">
                        Start Date
                      </Col>
                      <Col lg={4} className="fw-semibold">
                        End Date
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col lg={3} className="ms-2">
                        {selectedPlan?.title}
                      </Col>
                      <Col lg={4}>{moment().format("DD MMM YYYY")}</Col>
                      <Col lg={4}>
                        {moment(selectedPlan?.endDate).format("DD MMM YYYY")}
                      </Col>
                      <Col
                        lg={4}
                        className="mt-2 ms-2 fw-semibold invoice-icon-size plan-amount"
                      >
                        {selectedPlan?.price}
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </>
            )}
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center align-items-center p-4">
            <div className="d-flex flex-row gap-3">
              <CommonButton
                outline={true}
                className={
                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                }
                color={""}
                type={"reset"}
                icon={
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-1" />
                }
                buttonAction={toggleModal}
                buttonText={"Cancel"}
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />
              <CommonButton
                color={"secondary"}
                type={"submit"}
                buttonText={modalStep === 1 ? "Next" : "Confirm"}
                icon={
                  modalStep === 1 ? (
                    <i className="ri-play-mini-fill label-icon align-middle fs-16 me-2"></i>
                  ) : (
                    <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                  )
                }
                className={
                  "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                }
                buttonAction={handleConfirm}
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default ChangePlan;
